import type { Localized } from '../types';

type ServiceItem = {
  readonly title: string;
  readonly body: readonly string[];
};

type WhyItem = {
  readonly number: string;
  readonly heading?: string;
  readonly body: string;
  readonly description: string;
};

type TopContent = {
  readonly heroTitle: readonly string[];
  readonly heroLead: readonly string[];
  readonly about: readonly string[];
  readonly serviceTitle: string;
  readonly services: readonly ServiceItem[];
  readonly serviceButton: string;
  readonly whyTitle: string;
  readonly whyItems: readonly WhyItem[];
  readonly messageTitle: string;
  readonly messageText: readonly string[];
  readonly signRole: string;
  readonly signName: string;
  readonly messageButton: string;
};

export const topDict: Localized<TopContent> = {
  ja: {
    heroTitle: ['テクノロジーと金融洞察力で', '長期的な資産形成を支援'],
    heroLead: [
      'AIを活用した運用支援と、IFAによるサポートを通じて、',
      '一人ひとりに寄り添った資産形成を支援します',
    ],
    about: [
      'CJインベストメント株式会社は資産運用のアドバイスを提供する IFA（独立系ファイナンシャルアドバイザー）です。',
      '短期的な利益ではなく、長期的な価値を見据える。市場環境が変化し続ける時代だからこそ、短期的視点に左右されない、合理的な資産形成支援を大切にしています。',
    ],
    serviceTitle: 'サービス紹介',
    services: [
      {
        title: 'IT事業',
        body: [
          'AIを活用した資産形成支援サービス。',
          '楽天証券を活用した自動売買システムにより、データベースによる運用支援を提供しています。',
        ],
      },
      {
        title: '資産運用事業',
        body: [
          'お客様一人ひとりに合わせた資産形成サポート。',
          'IFAとして、投資・保険・ライフプランなど、中長期視点での支援を行います。',
        ],
      },
    ],
    serviceButton: '詳しく見る',
    whyTitle: '選ばれる理由',
    whyItems: [
      { number: '01', heading: 'AI Driven Investment', body: 'AIが導く、新しい資産形成のかたち',description:'膨大な市場データを分析し、投資判断をサポート。' },
      { number: '02', heading: 'Independent Advice', body: 'お客様本位の独立系アドバイス',description:'金融機関の販売方針に左右されず、お客様の利益を最優先に考えます。' },
      { number: '03', heading: 'Long-Term Partnership', body: '人生100年時代のパートナー',description:'資産運用から相続・事業承継まで、長期的な視点で伴走します。' },
    ],
    messageTitle: 'AIと金融の組み合わせで、更なる資産形成を促進します',
    messageText: [
      'テクノロジーの進化により、投資や資産形成、そしてビジネスのあり方は今、かつてないスピードで変革の時を迎えています。 私たちは「金融×IT」「保険×IT」というクロスドメインを最大の強みとし、 最先端のAI技術やFinTechを駆使して、社会に新しい価値を創造するプロフェッショナル集団です。',
      'これから投資を始めたい個人のお客様にも、AIや先進技術でビジネスの飛躍を目指す法人のお客様にも、 確かな技術力と専門知識を融合させた「最適なアンサー」をご提供いたします。 テクノロジーと金融の力で未来の可能性を切り拓くベストパートナーとして、私たちにぜひご期待ください。',
    ],
    signRole: '代表取締役',
    signName: '李 松',
    messageButton: '会社概要を見る',
  },
  zh: {
    heroTitle: ['融合科技创新与金融智慧', '陪伴客户实现长期资产增值'],
    heroLead: [
      '通过运用AI的投资支持与IFA的专业服务，',
      '为每一位客户量身定制资产积累方案。',
    ],
    about: [
      'CJ投资株式会社是提供资产管理咨询的IFA（独立财务顾问）。',
      '我们着眼于长期价值，而非短期利益。正因身处市场环境不断变化的时代，我们更重视不为短期视角所左右、合理而稳健的资产积累支持。',
    ],
    serviceTitle: '服务介绍',
    services: [
      {
        title: 'IT业务',
        body: [
          '运用AI的资产积累支持服务。',
          '通过基于乐天证券的自动交易系统，提供以数据库为支撑的投资运营支持。',
        ],
      },
      {
        title: '资产管理业务',
        body: [
          '为每一位客户量身定制的资产积累支持。',
          '作为IFA，从中长期视角提供投资、保险、人生规划等方面的支持。',
        ],
      },
    ],
    serviceButton: '查看详情',
    whyTitle: '被选择的理由',
    whyItems: [
      { number: '01', heading: 'AI驱动投资', body: 'AI辅助财富管理',description:'利用AI和数据分析，帮助客户做出更理性的投资决策。' },
      { number: '02', heading: '独立专业建议', body: '始终以客户利益为先',description:'站在客户立场，提供客观、中立的财富管理建议。' },
      { number: '03', heading: '长期合作伙伴', body: '陪伴财富稳健成长',description:'从资产增值到财富传承，长期陪伴客户实现目标。' },
    ],
    messageTitle: '以AI与金融的结合，进一步推动资产积累',
    messageText: [
      '随着科技的进步，投资、资产积累乃至商业模式正以前所未有的速度迎来变革之时。我们以「金融×IT」「保险×IT」的跨领域融合为最大优势，运用尖端的AI技术与FinTech，是一支为社会创造全新价值的专业团队。',
      '无论是希望开始投资的个人客户，还是力求借助AI与先进技术实现业务飞跃的法人客户，我们都将融合扎实的技术实力与专业知识，为您提供「最佳答案」。作为以科技与金融之力开拓未来可能性的最佳伙伴，敬请期待我们的表现。',
    ],
    signRole: '代表董事',
    signName: '李 松',
    messageButton: '查看公司简介',
  },
};
